
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { ReactNode } from 'react';


interface TableProps {
    children: ReactNode,
    ref?: any
}

export default function BasicTable({ children, ref, ...rest }: TableProps) {
    return (
        <TableContainer ref={ref} component={Paper} sx={{ width: '100%', maxWidth: '100%' }} style={{
            boxShadow: 'none'
        }} {...rest}>
            <Table sx={{ 
                minWidth: 200, 
                // border: '1px solid #B9B9B9' 
            }} aria-label="simple table">
                {children}
            </Table>
        </TableContainer>
    );
}